"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SimpleMegaPhone = void 0;
const react_1 = __importDefault(require("react"));
const SimpleMegaPhone = ({ size, color }) => {
    return (react_1.default.createElement("svg", { width: size, height: size, viewBox: "0 0 54 54", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
        react_1.default.createElement("path", { d: "M30.76 17.91v18.823a1.216 1.216 0 0 0 .542 1.013l1.672 1.115a1.217 1.217 0 0 0 1.856-.717l2.016-8.062", stroke: color || '#25CFBB', strokeWidth: "2.434", strokeLinecap: "round", strokeLinejoin: "round" }),
        react_1.default.createElement("path", { d: "M36.844 30.082a6.086 6.086 0 0 0 0-12.172h-6.086s-8.285 0-16.257-6.687a1.218 1.218 0 0 0-2.001.93v23.685a1.217 1.217 0 0 0 2 .93c7.973-6.686 16.258-6.686 16.258-6.686h6.086Z", stroke: color || '#25CFBB', strokeWidth: "2.434", strokeLinecap: "round", strokeLinejoin: "round" })));
};
exports.SimpleMegaPhone = SimpleMegaPhone;
